import service from '@/services/region/RegionService'

let regionTax = {
  code: 0,
  name: '',
  state: '',
  route: '',
  neighbourhood: '',
  price: 0,
}

export const regionModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    region: null,
    regionTax: null,
  },
  mutations: {
    SET_REGION(state, payload) {
      state.region = { ...payload }
    },
    SET_REGION_TAX(state, payload) {
      if (payload && payload[0])
        state.regionTax = {
          code: payload[0].CODIGO,
          name: payload[0].NOME,
          state: payload[0].ESTADO,
          route: payload[0].ROTANOME,
          neighbourhood: payload[0].BAIRRO,
          price: payload[0].VALORFRETE,
        }
      else state.regionTax = null
    },
  },
  actions: {
    /**
     * Consultar rota de região para obter valor do frete
     */
    async getRegionTax({ commit }, query) {
      const response = await service.getRegionTax(query)
      await commit('SET_REGION_TAX', response)
    },

    /**
     * Cria objeto vindo da consultas de cep
     */
    async setRegion({ commit }, payload) {
      await commit('SET_REGION', payload)
    },

    async setRegionTax({ commit }, payload) {
      await commit('SET_REGION_TAX', payload)
    },
  },
  getters: {
    regionTax: (state) => {
      console.log(state.regionTax)
      return state.regionTax
    },
    region: (state) => {
      return state.region
    },
  },
}
